import { useContext } from "react";
import StateContext from "../../state/stateContext";
import Shimmer from "../Shimmer/Shimmer";
import useQueryCommunityNews from "../Hooks/useQueryCommunityNews";
import useQueryChildData from "../Hooks/useQueryChildData";
import useQueryCommitment from "../Hooks/useQueryCommitment";
import useQueryFeeds from "../Hooks/useQueryFeeds";
window.rerenderCount = 0;

export function wrapDataShimmer(WrappedComponent, opts = {}) {
  const { 
    shimmerProps: shimmerDefaultProps={}, 
    requires: requiresDefault=[],
    shimmerItemCount: shimmerItemCountDefault=1,
    FallbackComponent: FallbackComponentDefault=() => null
  } = opts;
  return (props) => {
    const { shimmerProps=shimmerDefaultProps, shimmerItemCount=shimmerItemCountDefault, FallbackComponent=FallbackComponentDefault, requires=requiresDefault, ...componentProps } = props;
    const context = useContext(StateContext);
    const queryCommitment = useQueryCommitment(context);
    const queryChildData = useQueryChildData(context);
    const queryCommunityNews = useQueryCommunityNews(context);
    const queryFeeds = useQueryFeeds(context);
    const requiresData = [].concat(requires);
    const queryObjects = {
      "communityNews": queryCommunityNews,
      "commitment": queryCommitment,
      "child": queryChildData,
      "feeds": queryFeeds,
    };
    const { selectedCategory } = context.state;

    const isWaiting = requiresData.some(key => {
      return !!queryObjects?.[key]?.isWaiting;
    });

    const isError = requiresData.some(key => {
      return !!queryObjects?.[key]?.isError;
    });

    const showShimmer = isWaiting;
    const shimmerItems = [...new Array(shimmerItemCount)];

    // console.log("window.rerenderCount", ++window.rerenderCount);

    if (isError) {
      return <FallbackComponent {...componentProps} />;
    }

    if (showShimmer) {
      return shimmerItems.map((_,key) => 
        <Shimmer 
          key={key}
          className={`${shimmerProps?.classList || ""}`}
          isLoading={true}
          height={shimmerProps.height}
          {...shimmerProps}
        />
      );
    }

    const requiredData = requiresData.reduce((all, key) => {
      return {
        ...all,
        [key]: queryObjects[key]?.data
      };
    }, {});

    return (
      <WrappedComponent {...componentProps} selectedCategory={selectedCategory} requiredData={requiredData} />
    )
  }
}